import { Component } from '@angular/core';
import { BaseRow } from '../base-row';

@Component({
    selector: 'app-recovery-payment-item-row',
    templateUrl: './recovery-payment-item-row.component.html',
    styleUrls: ['./../base-row.component.scss'],
    standalone: false
})
export class RecoveryPaymentItemRowComponent extends BaseRow {

}
